// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__bcii9","icon":"style_icon__w299j","btn":"style_btn__Kfzr8"};